// extracted by mini-css-extract-plugin
module.exports = {"progress":"PageNavLeft_progress__ykU2x"};